<div class="view-form bg-default">
    <ng-container *transloco="let t">
    <div class="view-form__card sai-card">
        <!-- Loading Spinner -->
        <div *ngIf="isLoading" class="flex justify-center items-center h-20">
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        </div>
        <!-- Form Section -->
        <ng-container *ngIf="dataLoaded">
            <ng-container *ngIf="userData.logo">
                <div class="w-full flex justify-center mb-4">
                    <div class="sai-logo-avatar relative h-12 w-12 md:h-16 md:w-16 lg:h-20 lg:w-20 rounded-full p-1 shadow-lg flex items-center justify-center">
                        <img class="h-full w-full rounded-full object-cover"
                            [authSrc]="userData.logo ? userData.logo : '../../../../../../../assets/images/report.png' "
                            [alt]="t('Company Logo')">
                    </div>
                </div>
            </ng-container>
            <h1 class="view-form__title text-2xl font-bold text-center mb-6 px-4 lg:px-8">{{ formName }}</h1>
            <ng-container *ngIf="userData.slogan">
                <div class="view-form__slogan text-secondary text-sm md:text-md w-full text-center flex justify-center mb-6">{{ userData.slogan }}</div>
            </ng-container>
            @if(isFormEnabled){
                <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-6">
                    <ng-container *ngFor="let field of fields; trackBy: trackByField">
                        <!-- Input Field -->
                        <div *ngIf="field.componentStyle === 'input' && field.type !== 'date'">
                            <mat-form-field class="w-full fuse-mat-dense">
                                <mat-label class="whitespace-normal">{{ field.name | titlecase }}</mat-label>
                                <input matInput class="phone-input" [placeholder]="field.Placeholder"
                                    [type]="field.type === 'number' ? 'number' : 'text'"
                                    [formControlName]="field.fieldName" />

                                <mat-error *ngIf="form.get(field.fieldName)?.touched && form.get(field.fieldName)?.invalid">
                                    <ng-container *ngIf="form.get(field.fieldName)?.errors?.['required']">
                                        {{ field.name }} {{ t('is required') }}
                                    </ng-container>
                                    <ng-container *ngIf="form.get(field.fieldName)?.errors?.['minlength']">
                                        {{ t('Minimum allowed value is') }} {{ field.extras?.minValue }}
                                    </ng-container>
                                    <ng-container *ngIf="form.get(field.fieldName)?.errors?.['maxlength']">
                                        {{ t('Maximum allowed value is') }} {{ field.extras?.maxValue }}
                                    </ng-container>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Dropdown Field -->
                        <div *ngIf="field.componentStyle === 'dropdown'">
                            <mat-form-field class="w-full fuse-mat-dense">
                                <mat-label class="whitespace-normal">{{ field.name | titlecase }}</mat-label>
                                <mat-select [formControlName]="field.fieldName" [multiple]="field.isMultiple">
                                    <mat-option *ngFor="let option of field.options" [value]="option">{{ option }}</mat-option>
                                </mat-select>
                                <mat-error>
                                    <ng-container *ngIf="form.get(field.fieldName).hasError('required')">
                                        {{ field.name | titlecase }} {{ t('is required') }}
                                    </ng-container>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div *ngIf="field.componentStyle === 'slider'" class="slider-container">
                            <mat-label class="view-form__field-label font-medium text-secondary block mb-2 whitespace-normal">{{ field.name }}</mat-label>
                            <div class="w-full px-4">
                                <ngx-slider color="primary" [formControlName]="field.fieldName" [options]="field.sliderConfig">
                                </ngx-slider>
                            </div>
                        </div>

                        <!-- Textarea Field -->
                        <div *ngIf="field.componentStyle === 'textarea'">
                            <mat-form-field appearance="fill" class="w-full multi-line-label fuse-mat-dense">
                                <mat-label>{{ field.name }}</mat-label>
                                <textarea matInput [formControlName]="field.fieldName" rows="4"
                                    [placeholder]="field.Placeholder"></textarea>
                                <mat-error>
                                    <ng-container *ngIf="form.get(field.fieldName).hasError('required')">
                                        {{ field.name }} {{ t('is required') }}
                                    </ng-container>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <div *ngIf="field.componentStyle === 'input' && field.type === 'date'">
                            <mat-form-field class="w-full fuse-mat-dense">
                                <mat-label class="whitespace-normal">{{ field.name }}</mat-label>
                                <input matInput [matDatepicker]="picker" [formControlName]="field.fieldName"
                                    [placeholder]="field.Placeholder || t('Choose a date')" />
                                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                <mat-datepicker #picker></mat-datepicker>
                                <mat-error>
                                    <ng-container *ngIf="form.get(field.fieldName)?.hasError('required')">
                                        {{ field.name }} {{ t('is required') }}
                                    </ng-container>
                                </mat-error>
                            </mat-form-field>
                        </div>

                        <!-- Time Field -->
                        <div *ngIf="field.componentStyle === 'time'">
                            <mat-form-field class="w-full fuse-mat-dense">
                                <mat-label class="whitespace-normal">{{ field.name }}</mat-label>
                                <input matInput [ngxTimepicker]="timePicker" [placeholder]="field.Placeholder"
                                    [formControlName]="field.fieldName" readonly />
                                <ngx-material-timepicker #timePicker></ngx-material-timepicker>
                                <mat-error>
                                    <ng-container *ngIf="form.get(field.fieldName).hasError('required')">
                                        {{ field.name }} {{ t('is required') }}
                                    </ng-container>
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div *ngIf="field.componentStyle === 'slideToggle'">
                                <mat-slide-toggle [formControlName]="field.fieldName">
                                    {{ field.name }}
                                </mat-slide-toggle>
                                <mat-error>
                                    <ng-container *ngIf="form.get(field.fieldName).hasError('required')">
                                        {{ field.name }} {{ t('is required') }}
                                    </ng-container>
                                </mat-error>
                        </div>
                    </ng-container>

                    <button mat-flat-button type="submit" class="w-full" [disabled]="form.invalid"
                        [class.bg-primary]="!form.invalid" [class.bg-invalid]="form.invalid">{{ t('Submit') }}</button>
                </form>
            }@else{
                <div class="flex flex-col items-center justify-center pb-16 px-6 text-center">
                    <h2 class="view-form__closed text-lg font-semibold text-secondary italic">
                        "{{ t('This Hyperform is no longer accepting submissions') }}"
                    </h2>
                </div>
            }
        </ng-container>
    </div>
    </ng-container>
</div>
